module.exports = __webpack_public_path__ + "assets/nested.952852a4.svg";